export default __webpack_public_path__ + "static/media/down_icon.d79acf95.svg";